var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConsultantInstructionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_978",
    "data-name": "Group 978",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 23.999,
    viewBox: "0 0 24 23.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    width: 24,
    height: 23.999,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_977",
    "data-name": "Group 977",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    d: "M22.2,7.2h-3V5.4a1.8,1.8,0,0,0-1.8-1.8H16.2a1.8,1.8,0,0,1-1.8-1.8A1.8,1.8,0,0,0,12.6,0H1.8A1.8,1.8,0,0,0,0,1.8V22.2a.276.276,0,0,0,0,.046c0,.014,0,.031,0,.046q0,.086.014.166c0,.007,0,.014,0,.022.01.055.019.11.034.163a1.668,1.668,0,0,0,.05.166c.019.055.043.108.067.161s.053.1.082.154a1.667,1.667,0,0,0,.1.144,1.822,1.822,0,0,0,.442.427c.048.031.1.062.149.089s.1.05.144.072l.029.012a1.415,1.415,0,0,0,.142.05s.007,0,.012,0a1.5,1.5,0,0,0,.149.038.373.373,0,0,0,.05.01q.072.014.144.022h0A1.521,1.521,0,0,0,1.8,24H18.427a1.8,1.8,0,0,0,1.733-1.306l3.77-13.2A1.8,1.8,0,0,0,22.2,7.2M1.92,1.92H12.482A3.726,3.726,0,0,0,16.2,5.52h1.08V7.2H5.573a1.8,1.8,0,0,0-1.73,1.3L1.92,15.232ZM19.2,19.065l-.862,3.014H1.961l3.7-12.96H22.041Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultantInstructionIcon);
export default __webpack_public_path__ + "static/media/consultant_instruction_icon.a5266a32bf8fd7bfdd78a9a09f21b8b7.svg";
export { ForwardRef as ReactComponent };